import { create } from 'zustand';

import { PATHS } from '@/shared/constants/routes/paths';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { Project } from '@/shared/types/Project';

export type ResultDownloadKind = 'audio' | 'lipsync' | 'subtitles' | 'video';

export type ResultDownload = {
  at: number;
  kind: ResultDownloadKind;
  project: Project;
  spaceId?: string;
};

type ResultDownloadStore = {
  last: null | ResultDownload;
};

export const useResultDownloadStore = create<ResultDownloadStore>(() => ({ last: null }));

const SPACE_PATH = new RegExp(`^/${PATHS.spaces}/([^/]+)`);

export const getPathSpaceId = (pathname: string) => SPACE_PATH.exec(pathname)?.[1];

export const notifyResultDownloaded = (
  project: Project,
  kind: ResultDownloadKind = 'video',
  spaceId = getPathSpaceId(window.location.pathname),
) => {
  useResultDownloadStore.setState({ last: { at: Date.now(), kind, project, spaceId } });
};

export const reportResultDownloaded = (project: Project | undefined, kind: ResultDownloadKind = 'video') => {
  MixpanelEvents.anyResultDownloaded();
  if (project) notifyResultDownloaded(project, kind);
};
